import { type WorkspaceListResponse } from '@air/api/types';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

type WorkspacePlan = NonNullable<WorkspaceListResponse[0]>['plan'];

const API_ELIGIBLE_PLANS: WorkspacePlan[] = ['enterprise', 'demo', 'business'];

export const useIsApiEligiblePlan = () => {
  const { currentWorkspace } = useCurrentWorkspace();

  const isApiEligiblePlan = !!currentWorkspace && API_ELIGIBLE_PLANS.includes(currentWorkspace.plan);

  return { isApiEligiblePlan };
};
